









import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class EventSkeleton extends Vue {
  skeleton = [{ id: 1 }, { id: 2 }, { id: 3 }];
}
